/*
Handles matter tags, client tags, matter types, document types, office/branch list, document statuses


*/

import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { makeTagActions } from "../actions/tagActions";
import { openGlobalDialog } from "../actions/globalEditDialogActions";

import CustomizableTable from "./Tables/CustomizableTable";
import { MAIN_COLUMN_WIDTH, ID_COLUMN_WIDTH } from "./Tables/SortableTable";
import InteractiveTableCell from "./Tables/InteractiveTableCell";
import { ButtonWithIcon } from "./ButtonWithIcon";
import { DropDownButton } from "./DropDownButton";
import { LexWorkplaceGavelIcon } from "./LexWorkplaceIcons";
import { shortDateFormat } from "../utilities/utilities";
import { IconTag } from "@tabler/icons-react";
import {
	activeStatusTabFilterMap,
	statusColumn,
	lastModifiedColumn,
} from "./Tables/tagTableShared";

class TagManager extends Component {
	constructor(props, context) {
		super(props, context);

		this.deactivateRequest = this.deactivateRequest.bind(this);
		this.activateRequest = this.activateRequest.bind(this);
		this.newButtonHandler = this.newButtonHandler.bind(this);
		this.editHandler = this.editHandler.bind(this);

		this.columnConfig = [
			{ Header: "ID", accessor: "id", width: ID_COLUMN_WIDTH },
			{
				Header: this.props.objectName,
				accessor: "name",
				width: MAIN_COLUMN_WIDTH,
				Cell: (row) => (
					<InteractiveTableCell
						menuItems={
							row.original.status === "active"
								? [
										{
											text:
												"Edit " + this.props.objectName,
											onSelect: () =>
												this.editHandler(row.original),
											disabled: !this.props.crudRight,
											disabledHoverText: !this.props
												.crudRight
												? "You do not have permission to edit " +
													this.props.objectName.toLowerCase() +
													"s"
												: "",
										},
										{
											text:
												"Deactivate " +
												this.props.objectName,
											onSelect: () =>
												this.deactivateRequest(
													row.original.id
												),
											disabled: !this.props.crudRight,
											disabledHoverText: !this.props
												.crudRight
												? "You do not have permission to edit " +
													this.props.objectName.toLowerCase() +
													"s"
												: "",
										},
									]
								: [
										{
											text:
												"Edit " + this.props.objectName,
											onSelect: () =>
												this.editHandler(row.original),
											disabled: !this.props.crudRight,
											disabledHoverText: !this.props
												.crudRight
												? "You do not have permission to edit " +
													this.props.objectName.toLowerCase() +
													"s"
												: "",
										},
										{
											text:
												"Activate " +
												this.props.objectName,
											onSelect: () =>
												this.activateRequest(
													row.original.id
												),
											disabled: !this.props.crudRight,
											disabledHoverText: !this.props
												.crudRight
												? "You do not have permission to edit " +
													this.props.objectName.toLowerCase() +
													"s"
												: "",
										},
										{
											text:
												"Delete " +
												this.props.objectName,
											onSelect: () =>
												this.deleteRequest(
													row.original.id
												),
											disabled: !this.props.crudRight,
											disabledHoverText: !this.props
												.crudRight
												? "You do not have permission to delete " +
													this.props.objectName.toLowerCase() +
													"s"
												: "",
										},
									]
						}
					>
						<span>{row.original.name}</span>
					</InteractiveTableCell>
				),
				wildcard: true,
			},
			statusColumn,
			{
				Header: "Created By",
				accessor: "createdBy",
				wildcard: true,
			},
			lastModifiedColumn,
		];
	}

	deactivateRequest(id) {
		this.props.deactivateTags([id]);
	}
	activateRequest(id) {
		this.props.activateTags([id]);
	}
	deleteRequest(id) {
		this.props.deleteTags([id]);
	}
	componentDidMount() {
		this.props.fetchTags();
	}
	newButtonHandler() {
		this.props.openGlobalDialog(
			{
				label: "New " + this.props.objectName,
				submitButtonLabel: "Create " + this.props.objectName,
			},
			(state) => {
				this.props.createTags([state.value]);
			},
			(state) => {
				return {
					canSubmit: state.value !== "",
					erroMessage: "",
				};
			}
		);
	}
	editHandler(row) {
		this.props.openGlobalDialog(
			{
				label: "Edit " + this.props.objectName,
				value: row.name,
				submitButtonLabel: "Update " + this.props.objectName,
			},
			(state) => {
				this.props.updateTags([{ id: row.id, name: state.value }]);
			},
			(state) => {
				return {
					canSubmit: state.value !== "" && state.value !== row.name,
					erroMessage: "",
				};
			}
		);
	}

	render() {
		return (
			<div className="fullHeightFlex noDefaultMargin">
				<CustomizableTable
					actionButtons={({ openCsvExport }) => (
						<div style={{ display: "flex", gap: 8 }}>
							<ButtonWithIcon
								handler={this.newButtonHandler}
								buttonText={"New " + this.props.objectName}
								disabled={!this.props.crudRight}
								disabledHoverText={
									!this.props.crudRight
										? "You do not have permission to create " +
											this.props.objectName.toLowerCase() +
											"s"
										: ""
								}
								iconComponent={
									<IconTag
										size={16}
										style={{ verticalAlign: "middle" }}
									/>
								}
							/>
							<DropDownButton
								title="Actions"
								pullRight
								iconComponent={<LexWorkplaceGavelIcon />}
								menuItems={[
									{
										text: "Export Data as CSV",
										onSelect: openCsvExport,
									},
								]}
							/>
						</div>
					)}
					tabsFilterMap={activeStatusTabFilterMap}
					defaultTabFilterValue="Active"
					className="fullWidth"
					data={this.props.tagsData}
					autoResize
					columns={this.columnConfig}
					noResultsText={"No items here"}
					tableUniqueID={this.props.tableUniqueID}
					csvExport={{
						csvColumnRenderers: {
							lastUpdated: (val) =>
								val ? shortDateFormat(val) : "",
						},
						fileName: this.props.csvFileName,
					}}
				/>
			</div>
		);
	}
}
TagManager.propTypes = {
	fetchTags: PropTypes.func.isRequired,
};

const managerConfigs = {
	ClientTag: {
		objectName: "Client Tag",
		csvFileName: "client-tags",
		tableUniqueID: "/manageClientTags",
		endpoint: "/client/tags",
		dataSelector: (state) => state.client.availableClientTags,
		crudRightKey: "CRUD_CLIENT_TAGS",
	},
	MatterTag: {
		objectName: "Matter Tag",
		csvFileName: "matter-tags",
		tableUniqueID: "/manageMatterTags",
		endpoint: "/matter/tags",
		dataSelector: (state) => state.matter.availableMatterTags,
		crudRightKey: "CRUD_MATTER_TAGS",
	},
	MatterType: {
		objectName: "Matter Type",
		csvFileName: "matter-types",
		tableUniqueID: "/manageMatterTypes",
		endpoint: "/matters/types",
		dataSelector: (state) => state.matter.availableMatterTypes,
		crudRightKey: "CRUD_MATTER_TYPES",
	},
	OfficeBranch: {
		objectName: "Location",
		csvFileName: "locations",
		tableUniqueID: "/manageOfficeBranch",
		endpoint: "/officeBranch",
		dataSelector: (state) => state.matter.availableOfficeBranches,
		crudRightKey: "CRUD_OFFICE_LOCATIONS",
	},
	DocumentTag: {
		objectName: "Document Tag",
		csvFileName: "document-tags",
		tableUniqueID: "/manageDocumentTags",
		endpoint: "/document/tags",
		dataSelector: (state) => state.document.availableDocumentTags,
		crudRightKey: "CRUD_DOCUMENT_TAGS",
	},
	DocumentType: {
		objectName: "Document Type",
		csvFileName: "document-types",
		tableUniqueID: "/manageDocumentTypes",
		endpoint: "/document/types",
		dataSelector: (state) => state.document.availableDocumentTypes,
		crudRightKey: "CRUD_DOCUMENT_TYPES",
	},
	DocumentStatus: {
		objectName: "Document Status",
		csvFileName: "document-statuses",
		tableUniqueID: "/manageDocumentStatuses",
		endpoint: "/document/status",
		dataSelector: (state) => state.document.availableDocumentStatuses,
		crudRightKey: "CRUD_DOCUMENT_STATUSES",
	},
};

function buildManagerComponent(config) {
	const actions = makeTagActions(config.endpoint);
	return connect(
		(state) => ({
			tableUniqueID: config.tableUniqueID,
			tagsData: config.dataSelector(state),
			objectName: config.objectName,
			csvFileName: config.csvFileName,
			crudRight: state.user.userRights[config.crudRightKey],
		}),
		{
			...actions,
			openGlobalDialog,
		}
	)(TagManager);
}

const ClientTagManager = buildManagerComponent(managerConfigs.ClientTag);
const MatterTagManager = buildManagerComponent(managerConfigs.MatterTag);
const MatterTypeManager = buildManagerComponent(managerConfigs.MatterType);
const OfficeBranchManager = buildManagerComponent(managerConfigs.OfficeBranch);
const DocumentTagManager = buildManagerComponent(managerConfigs.DocumentTag);
const DocumentTypeManager = buildManagerComponent(managerConfigs.DocumentType);
const DocumentStatusManager = buildManagerComponent(
	managerConfigs.DocumentStatus
);

export {
	ClientTagManager,
	MatterTagManager,
	MatterTypeManager,
	OfficeBranchManager,
	DocumentTagManager,
	DocumentTypeManager,
	DocumentStatusManager,
};
